"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppProviders = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AuthProvider_1 = require("./AuthProvider");
const InactivityProvider_1 = require("./InactivityProvider");
const ToastProvider_1 = require("./ToastProvider");
const UiProvider_1 = require("./UiProvider");
const DegreePlansProvider_1 = require("./DegreePlansProvider");
const CohortsProvider_1 = require("./CohortsProvider");
const ErrorBoundary_1 = require("../components/ErrorBoundary");
/**
 * AppProviders component that wraps the application with all context providers
 */
const AppProviders = ({ children }) => {
    return ((0, jsx_runtime_1.jsx)(ErrorBoundary_1.ErrorBoundary, { children: (0, jsx_runtime_1.jsx)(AuthProvider_1.AuthProvider, { children: (0, jsx_runtime_1.jsx)(InactivityProvider_1.InactivityProvider, { children: (0, jsx_runtime_1.jsx)(ToastProvider_1.ToastProvider, { children: (0, jsx_runtime_1.jsx)(UiProvider_1.UiProvider, { children: (0, jsx_runtime_1.jsx)(DegreePlansProvider_1.DegreePlansProvider, { children: (0, jsx_runtime_1.jsx)(CohortsProvider_1.CohortsProvider, { children: children }) }) }) }) }) }) }));
};
exports.AppProviders = AppProviders;
